<template>
  <div style="height: 100%">
    <div
      class="rms-container"
      infinite-scroll-disabled="loading"
      v-infinite-scroll="loadMore"
      infinite-scroll-distance="10"
    >
      <!-- 搜索 -->
      <div class="search">
        <el-input
          placeholder="客户"
          v-model.trim="formInline.queryStr"
          size="small"
        >
          <el-button slot="append" size="small" @click="query()"
            >查询</el-button
          >
        </el-input>
      </div>
      <div style="height: 54px"></div>

      <!-- 列表 -->
      <div class="list-container" v-if="tableList.length > 0">
        <el-card class="item" v-for="(item, index) in tableList" :key="index">
          <div class="content" @click="itemClick(item)">
            <div class="text row">
              <div class="cell-l">{{ item.kunnr }}</div>
              <div class="cell-r">{{ item.kunnrT }}</div>
            </div>
            <div class="text row" v-if="formInline.type == '2'">
              <div class="cell-l">{{ item.xref2 }}</div>
              <div class="cell-r">{{ item.kunpyName }}</div>
            </div>
            <div class="text">
              <div>{{ item.feedbackRemark }}</div>
              <div class="small">{{ item.feedbackTime | formatDay }}</div>
            </div>
          </div>
          <div class="btn">
            <el-button size="mini" @click="openFeedback(item)">反馈</el-button>
          </div>
        </el-card>
      </div>

      <!-- 加载更多 -->
      <div class="scroll-more" v-if="loading">加载中...</div>
      <div class="scroll-more" v-if="tableList.length > 0 && listsClose">
        没有更多了
      </div>
      <el-empty
        description="暂无数据"
        v-if="tableList.length == 0 && listsClose"
      ></el-empty>

      <!-- 反馈弹层 -->
      <el-dialog
        title="反馈"
        class="revise-content"
        center
        :visible.sync="changeFlag"
        fullscreen
        :modal="false"
      >
        <v-RMSFeedback
          :pageData="changeData"
          @successFeedback="successFeedback"
          v-if="changeFlag"
        ></v-RMSFeedback>
      </el-dialog>
    </div>
    <!-- 水印 -->
    <v-Watermark
      v-if="watermarkContent"
      :content="watermarkContent"
    ></v-Watermark>
  </div>
</template>

<script>
import util from "../../../common/util";
import RMSDetail from "../../../components/RMS/detail";
import RMSFeedback from "../../../components/RMS/feedback";
import Watermark from "../../../components/RMS/watermark";
export default {
  name: "RMSH5List",
  components: {
    "v-RMSDetail": RMSDetail,
    "v-RMSFeedback": RMSFeedback,
    "v-Watermark": Watermark,
  },
  data() {
    return {
      uName: sessionStorage.getItem("UNAME"),
      //form
      formInline: {
        isMobile: 1,
        paramType: 1,
        queryStr: ""
      },
      tableList: [], //列表
      //分页
      paginationConf: {
        pageNum: 0,
        pageSize: 15,
      },
      loading: false,
      listsClose: false,
      changeFlag: false, //反馈
      changeData: {}, //反馈传参
      watermarkContent: null, //水印
      formSet: {
        feedbackSelect: null,
      },
    };
  },
  filters: {
    formatDay(time) {
      return util.formatDate(time);
    },
    formatYuan(val) {
      let str = val ? val + "元" : "0.00元";
      return str;
    },
  },
  created() {
    this.watermarkContent =
      sessionStorage.getItem("NICKNAME") +
      (sessionStorage.getItem("MOBILE").toString() != "null"
        ? sessionStorage.getItem("MOBILE").slice(-4)
        : "");
    document.title = this.$route.query.dataty;
    this.formInline.type = this.$route.query.type;
    this.loadMore();
  },
  methods: {
    // 初始化
    async init() {
      let res = await this.$api.receivableQueryParam({
        ...this.formInline,
        ...this.paginationConf,
        ...this.$route.query,
      });
      if (res.code === 200 && res.result) {
        this.tableList = this.tableList.concat(res.result);
        if (res.result.length < this.paginationConf.pageSize) {
          this.listsClose = true;
        }
      } else {
        this.listsClose = true;
      }
    },
    // 查询
    query() {
      this.tableList = [];
      this.paginationConf.pageNum = 0;
      this.loading = false;
      this.listsClose = false;
      this.loadMore();
    },
    // 加载列表数据/滑到底部自动加载
    loadMore() {
      if (this.listsClose) {
        return false;
      }
      this.loading = true;
      setTimeout(async () => {
        this.paginationConf.pageNum += 1;
        await this.init();
        this.loading = false;
      }, 200);
    },
    /**
     * 反馈状态筛选映射：已反馈=1，未反馈=2，反馈过期=3，全部=0
     */
    changeFeedback(feedback) {
      if (feedback === "已反馈") {
        this.formInline.feedback = "1";
        return;
      }
      if (feedback === "未反馈") {
        this.formInline.feedback = "2";
        return;
      }
      if (feedback === "反馈过期") {
        this.formInline.feedback = "3";
        return;
      }
      this.formInline.feedback = "0";
    },
    // 反馈-打开弹窗
    openFeedback(obj) {
      const { type, zproject1 } = this.$route.query;
      this.changeData = {};
      this.changeData.type = this.formInline.type;
      this.changeData.clientType = "mobile";
      this.changeData.isBatch = true;
      this.changeData.params = {
        pageSize: 99999,
        type,
        zproject1,
        kunnr: obj.kunnr,
      };
      this.changeFlag = true;
    },
    // 反馈-关闭
    successFeedback(flag) {
      this.changeFlag = false;
      if (flag) {
        this.query();
      }
    },
    itemClick(item) {
      const { type, zproject1 } = this.$route.query;
      this.$router.push({
        path: `/RMS/H5/orderList?type=${type}&zproject1=${zproject1}&kunnr=${item.kunnr}`,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.rms-container {
  height: 100%;
  overflow-y: auto;
  position: relative;
  z-index: 2;
  .search {
    padding: 10px 15px;
    background-color: #fff;
    border-bottom: 1px solid #ececec;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  .list-container {
    margin: 0 10px;
    .item {
      margin-top: 10px;
      font-size: 12px;
      /deep/.el-card__header {
        padding: 0;
      }
      /deep/.el-card__body {
        padding: 0;
      }
      .title {
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        .cell {
          padding: 0 2px;
          white-space: nowrap;
          &.cell-l {
            width: calc(~"100% - 140px");
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &.cell-c {
            width: 80px;
            text-align: right;
          }
          &.cell-r {
            width: 46px;
            text-align: right;
            color: #d9001b;
          }
        }
      }
      .content {
        padding: 10px;
        .row {
          display: flex;
        }
        .text {
          line-height: 16px;
          padding: 3px 0;
          .small {
            color: #999;
          }
        }
        .cell-l {
          min-width: 90px;
        }
      }
      .btn {
        border-top: 1px solid #ebeef5;
        padding: 5px 10px;
        text-align: right;
      }
    }
  }
}
.scroll-more {
  padding: 15px 0;
  text-align: center;
  font-size: 14px;
  color: #5e6d82;
}
</style>
